var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#7D78C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7043 13.5197C24.034 13.5197 23.4637 13.9855 23.3036 14.6133H28.6863C28.5262 13.9855 27.9559 13.5197 27.2856 13.5197H24.7043ZM30.2071 14.6126H32.1881C34.2891 14.6126 36 16.3443 36 18.4709C36 18.4709 35.94 19.3711 35.92 20.6248C35.918 20.724 35.8699 20.8212 35.7909 20.88C35.3097 21.2354 34.8694 21.5291 34.8294 21.5493C33.1686 22.6632 31.2386 23.447 29.1826 23.8369C29.0485 23.8632 28.9165 23.7934 28.8484 23.6739C28.2721 22.6754 27.1956 22.0253 25.995 22.0253C24.8024 22.0253 23.7159 22.6683 23.1226 23.6678C23.0535 23.7853 22.9235 23.8531 22.7904 23.8278C20.7514 23.4369 18.8214 22.6541 17.1706 21.5594L16.2101 20.8911C16.1301 20.8405 16.08 20.7493 16.08 20.6481C16.05 20.1316 16 18.4709 16 18.4709C16 16.3443 17.7109 14.6126 19.8119 14.6126H21.7829C21.973 13.1443 23.2036 12 24.7044 12H27.2856C28.7864 12 30.017 13.1443 30.2071 14.6126ZM35.6598 22.8147L35.6198 22.8349C33.5988 24.1919 31.1676 25.0931 28.6163 25.4678C28.2561 25.5184 27.896 25.2855 27.7959 24.921C27.5758 24.0906 26.8655 23.5438 26.015 23.5438H26.005H25.985C25.1346 23.5438 24.4242 24.0906 24.2041 24.921C24.1041 25.2855 23.7439 25.5184 23.3837 25.4678C20.8324 25.0931 18.4012 24.1919 16.3802 22.8349C16.3702 22.8248 16.2702 22.764 16.1901 22.8147C16.1001 22.8653 16.1001 22.9868 16.1001 22.9868L16.1701 28.1513C16.1701 30.2779 17.871 31.9994 19.972 31.9994H32.018C34.1191 31.9994 35.8199 30.2779 35.8199 28.1513L35.9 22.9868C35.9 22.9868 35.9 22.8653 35.8099 22.8147C35.7599 22.7843 35.6999 22.7944 35.6598 22.8147ZM26.7454 27.0577C26.7454 27.483 26.4152 27.8172 25.995 27.8172C25.5848 27.8172 25.2446 27.483 25.2446 27.0577V25.7513C25.2446 25.3362 25.5848 24.9919 25.995 24.9919C26.4152 24.9919 26.7454 25.3362 26.7454 25.7513V27.0577Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHBriefcase);
export default __webpack_public_path__ + "static/media/HBriefcase.c997f132.svg";
export { ForwardRef as ReactComponent };